import cleanedFilename from '~/util/cleanedFilename';

export default {
  IMG_ELEMENT: `${cleanedFilename(__filename)}-img-element`,
  IMAGE_PLACEHOLDER: `${cleanedFilename(__filename)}-image-placeholder`,
};
